module.exports = __webpack_public_path__ + "static/img/sou-w@2x.a37aa51c.png";